function PreloadLinks() {
  return null;
}
export {
  PreloadLinks
};
//# sourceMappingURL=PreloadLinks.native.js.map
